import "../css/ClientFilters.css";
import "../css/OptimizationFilters.css";

const STATUS_OPTIONS = ["DRAFT", "NEEDS_REVIEW", "IN_PROGRESS", "DISQUALIFIED", "COMPLETED"];

// "NEEDS_REVIEW" -> "Needs review"
const statusLabel = (s) => {
  const text = s.toLowerCase().replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const FILTER_KEYS = ["candidateId", "clientId", "status", "jdTitle", "startDate", "endDate", "minAtsScore"];

export default function OptimizationFilters({ value, onChange, onApply, onReset, candidates = [], clients = [] }) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });

  // Reset is only useful when at least one filter has a value.
  const hasAnyFilter = FILTER_KEYS.some((k) => value[k]);

  const controlClass = (key) => `cf-control${value[key] ? " is-set" : ""}`;

  // Pressing Enter in the text/number boxes applies the filters.
  const applyOnEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onApply();
    }
  };

  return (
    <div className="cf-bar">
      <div className="cf-grid cf-grid-opt">
        <div className="cf-field">
          <label htmlFor="opt-candidate">Candidate</label>
          <select id="opt-candidate" className={controlClass("candidateId")} value={value.candidateId || ""} onChange={set("candidateId")}>
            <option value="">All candidates</option>
            {candidates.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="cf-field">
          <label htmlFor="opt-client">Client</label>
          <select id="opt-client" className={controlClass("clientId")} value={value.clientId || ""} onChange={set("clientId")}>
            <option value="">All clients</option>
            {clients.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="cf-field">
          <label htmlFor="opt-status">Status</label>
          <select id="opt-status" className={controlClass("status")} value={value.status || ""} onChange={set("status")}>
            <option value="">All statuses</option>
            {STATUS_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {statusLabel(s)}
              </option>
            ))}
          </select>
        </div>

        <div className="cf-field">
          <label htmlFor="opt-jd">Job title</label>
          <input
            id="opt-jd"
            type="text"
            className={controlClass("jdTitle")}
            value={value.jdTitle || ""}
            onChange={set("jdTitle")}
            onKeyDown={applyOnEnter}
            placeholder="e.g. Senior Java Developer"
          />
        </div>

        <div className="cf-field">
          <label htmlFor="opt-from">Created from</label>
          <input
            id="opt-from"
            type="date"
            className={controlClass("startDate")}
            value={value.startDate || ""}
            max={value.endDate || undefined}
            onChange={set("startDate")}
          />
        </div>

        <div className="cf-field">
          <label htmlFor="opt-to">Created to</label>
          <input
            id="opt-to"
            type="date"
            className={controlClass("endDate")}
            value={value.endDate || ""}
            min={value.startDate || undefined}
            onChange={set("endDate")}
          />
        </div>

        <div className="cf-field">
          <label htmlFor="opt-ats">Min. ATS score</label>
          <input
            id="opt-ats"
            type="number"
            min="0"
            max="100"
            className={controlClass("minAtsScore")}
            value={value.minAtsScore || ""}
            onChange={set("minAtsScore")}
            onKeyDown={applyOnEnter}
            placeholder="e.g. 70"
          />
        </div>

        <div className="cf-actions">
          <button type="button" className="cf-btn cf-btn-secondary" onClick={onReset} disabled={!hasAnyFilter}>
            Reset
          </button>
          <button type="button" className="cf-btn cf-btn-primary" onClick={onApply}>
            Apply filters
          </button>
        </div>
      </div>
    </div>
  );
}
